var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{staticClass:"readonly-textarea mt-2",domProps:{"value":_vm.model},on:{"input":function($event){return _vm.$forceUpdate()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }